module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.code > 0) ? _c('div', {
    staticClass: "success"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(!this.boletoUrl) ? _c('div', {
    staticClass: "error-box text-center"
  }, [_c('h1', {
    staticClass: "bold"
  }, [_vm._v("Oops!")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("Alguma coisa deu errada!")]), _vm._v(" "), (_vm.cmpId === 120) ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("No momento um dos canais de finalização está indisponível. Tente novamente mais tarde ou entre em contato com a Central de Relacionamento.")]) : [(_vm.validacaoFraude && _vm.type == 'newVehicle') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'newVehicle') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível confirmar o pagamento da sua adesão, por favor verifique os dados do seu cartão.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'newContract') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'newContract') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua solicitação. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'adhesion') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'adhesion') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua adesão. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.type == 'replaceTag') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir a substituição do TAG. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'recharge') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'recharge') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua recarga. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'reprocess') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'reprocess') ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível reprocessar seu pedido. Tente novamente.")]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "text-center margin-30"
  }, [(_vm.type == 'adhesion') ? _c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doLogin()
      }
    }
  }, [_vm._v("\n                Reprocessar\n              ")]) : (_vm.type == 'reprocess') ? _c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paraPedidosReprocessamento()
      }
    }
  }, [_vm._v("\n                Reprocessar\n              ")]) : _c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paraPedidos()
      }
    }
  }, [_vm._v("\n                Reprocessar\n              ")])])], 2) : _c('div', {
    staticClass: "error-box text-center"
  }, [_c('h1', {
    staticClass: "bold"
  }, [_vm._v("Oops!")]), _vm._v(" "), (this.msgErrorResp) ? _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v(_vm._s(this.msgErrorResp))]) : _c('p', {
    staticClass: "margin-20 line-height-20"
  }, [_vm._v("Não foi possível gerar o boleto da sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paraPlanos()
      }
    }
  }, [_vm._v("\n            Voltar\n          ")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-3fa3674e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/error.vue
// module id = 2107
// module chunks = 1